/**
 * Finds the pre-defined validation message for a given form field.
 * @param {Array<Object>} messages The source list of messages to look through.
 * @param {string} ref The identifier of a message in the source.
 * @param {string} [code] The specific error code, if needed.
 * @returns {string} The found message, or an empty string if not found.
 */
export function getFieldValidationMessage(messages, ref, code = undefined) {
  const field = code
    ? messages.find(item => item.ref === ref && item.code === code)
    : messages.find(item => item.ref === ref);
  return field ? field.message : '';
}

/**
 * Gets a concatenated string of accessible descriptions for a form field.
 * @param {Array<Object>} messages The source list of messages.
 * @param {string} ref The identifier of a message in the source.
 * @returns {string} A space-separated string of messages.
 */
export function getFieldAccessibleDescription(messages, ref) {
  const list = messages.filter(item => item.ref === ref);

  if (list && list.length > 0) {
    // Use Array.prototype.map and Array.prototype.join for a more functional approach
    return list.map(item => item.message).join(' ');
  }

  return '';
}

// Retain default export for backward compatibility, if needed
export default {
  getFieldValidationMessage,
  getFieldAccessibleDescription
};
